import { render, staticRenderFns } from "./cdetchitolaw.vue?vue&type=template&id=1039c2a8&scoped=true&"
import script from "./cdetchitolaw.vue?vue&type=script&lang=js&"
export * from "./cdetchitolaw.vue?vue&type=script&lang=js&"
import style0 from "./cdetchitolaw.vue?vue&type=style&index=0&id=1039c2a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1039c2a8",
  null
  
)

export default component.exports